import { Routes } from '@angular/router';
import { DefaultComponent } from './Modules/Home/Components/default/default.component';
import { LoginComponent } from './Modules/Home/Components/login/login.component';
import { ContactComponent } from './Modules/Home/Components/contact/contact.component';
import { AboutComponent } from './Modules/Home/Components/about/about.component';
import { ProductComponent } from './Modules/Home/Components/product/product.component';
import { CartComponent } from './Modules/Home/Components/cart/cart.component';
import { DashboardComponent } from './Modules/User/Components/dashboard/dashboard.component';
import { BookDetailsComponent } from './Modules/User/Components/book-details/book-details.component';
import { EBookComponent } from './Modules/User/Components/e-book/e-book.component';
import { AuthGuard } from './Services/guards/auth.guard';
import { CheckoutComponent } from './Modules/Home/Components/checkout/checkout.component';
import { FaqComponent } from './Modules/Home/Components/faq/faq.component';
import { FreeMockComponent } from './Modules/MockTest/Components/free-mock/free-mock.component';
import { RequiredConfigurationComponent } from './Modules/MockTest/Components/required-configuration/required-configuration.component';
import { VerificationComponent } from './Modules/MockTest/Components/verification/verification.component';
import { ExamComponent } from './Modules/MockTest/Components/exam/exam.component';
import { MyOrderComponent } from './Modules/User/Components/my-order/my-order.component';
import { PaymentSuccessComponent } from './Modules/Home/Components/payment-success/payment-success.component';

import { PrivacyPolicyComponent } from './Modules/Home/Components/privacy-policy/privacy-policy.component';
import { TermsConditionComponent } from './Modules/Home/Components/terms-condition/terms-condition.component';
import { CancellationRefundComponent } from './Modules/Home/Components/cancellation-refund/cancellation-refund.component';

import { ReportComponent } from './Modules/User/Components/report/report.component';
import { ViewProgressReportComponent } from './Modules/User/Components/report/view-progress-report/view-progress-report.component';
import { MyplanComponent } from './Modules/User/Components/myplan/myplan.component';

import { SiblingDetailComponent } from './Modules/Home/Components/sibling-detail/sibling-detail.component';
import { MychildComponent } from './Modules/Home/Components/mychild/mychild.component';
import { MyMockTestComponent } from './Modules/User/Components/my-mock-test/my-mock-test.component';
import { MyStudyComponent } from './Modules/Home/Components/my-study/my-study.component';
import { BuyPruductsComponent } from './Modules/Home/Components/buy-pruducts/buy-pruducts.component';
import { UpdateUserDetailsComponent } from './Modules/Home/Components/update-user-details/update-user-details.component';
import { BuyBookComponent } from './buy-book/buy-book.component';


export const routes: Routes = [
    { path: '', component: DefaultComponent },
    { path: 'login', component: LoginComponent },
    { path: 'contact', component: ContactComponent },
    { path: "about", component: AboutComponent },
    { path: "product", component: ProductComponent },
    { path: "cart", component: CartComponent },
    { path: "checkout", component: CheckoutComponent, canActivate: [AuthGuard] },
    { path: "faq", component: FaqComponent },
    { path: 'paymentsuccess', component: PaymentSuccessComponent },
    { path: "privacy-policy", component: PrivacyPolicyComponent },
    { path: "terms-conditions", component: TermsConditionComponent },
    { path: "cancellation-refund-policy", component: CancellationRefundComponent },


    { path: 'dashboard', component: DashboardComponent, canActivate: [AuthGuard] },
    { path: 'book-details', component: BookDetailsComponent, canActivate: [AuthGuard] },
    { path: 'eBook', component: EBookComponent, canActivate: [AuthGuard] },
    { path: 'myOrder', component: MyOrderComponent, canActivate: [AuthGuard] },
    { path: 'report', component: ReportComponent, canActivate: [AuthGuard] },
    { path: 'ProgressReport', component: ViewProgressReportComponent, canActivate: [AuthGuard] },
    { path: 'MyPlan', component: MyplanComponent, canActivate: [AuthGuard] },
    { path: 'MyMockTest', component: MyMockTestComponent, canActivate: [AuthGuard] },

    { path: 'freemock', component: FreeMockComponent, canActivate: [AuthGuard] },
    { path: 'required-configuration', component: RequiredConfigurationComponent, canActivate: [AuthGuard] },
    { path: 'verification', component: VerificationComponent, canActivate: [AuthGuard] },
    { path: 'exam', component: ExamComponent, canActivate: [AuthGuard] },
    { path: 'mychild', component: MychildComponent, canActivate: [AuthGuard] },
    { path: 'my-study', component: MyStudyComponent, canActivate: [AuthGuard] },
    { path: 'buy-products', component: BuyPruductsComponent, canActivate: [AuthGuard] },
    { path: 'sibling-detail', component: SiblingDetailComponent, canActivate: [AuthGuard] },
    { path: 'update-user', component: UpdateUserDetailsComponent, canActivate: [AuthGuard] },
      { path: 'buy-book', component: BuyBookComponent, canActivate: [AuthGuard] }

];
